import React, { useState, useEffect } from 'react'
import logo from "../images/logo.png";
import { Link, useNavigate, useLocation } from 'react-router-dom'
import axios from 'axios'
import { server_API } from '../config'
import login from '../images/login.png'
import { FaEye } from "react-icons/fa";
import { FaEyeSlash } from "react-icons/fa";
// import { useSelector, useDispatch } from 'react-redux'
// import { selectUuid, updateUserId } from '../features/userid'
import axiosInstance from '../axiosInstance'


// 4. Remove "Total" from total applications recieved

const ResetPassword = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const { id } = location.state

  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [confirmPassword, setConfirmPassword] = useState('')
  const [display1, setDisplay1] = useState(false)
  const [display2, setDisplay2] = useState(false)
  const [checked, setChecked] = useState(false)
  const [existing, setExisting] = useState(false)


  const nav = () => {
    const formData = new FormData()
    formData.append('uuid', id)
    formData.append('status', 'accepted')
    formData.append('password', password)
    axiosInstance.patch(`/v2/user/update`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
      .then((response) => {
        console.log(response)
        if (response.data.ATSEnabled) {
          window.location.href = "https://northstarz.ai/ats/#/home"
        }
        else {
          window.location.href = "https://northstarz.ai/app/#/home"
        }
        // axiosInstance.get(`/v2/user/getuser`)
        // .then((response)=>{
        //   console.log(response)

        // })
        // .catch((err)=>{
        //   console.log(err)
        // })
      })
      .catch((error) => {
        console.log(error)
      })
  }
  // axiosInstance.patch(`/v1/user/update`,{
  //   uuid:response.data.success,
  //   status:"accepted"
  // })
  // .then((response)=>{
  //   console.log(response)
  //   navigate('/home')
  // })
  // .catch((error)=>{
  //   console.log(error)
  // })
  return (
    <div className="bg-cover min-h-screen p-5 bgGradient" >
      <div className="p-2">
        <img src={logo} className="h-10 mb-10"></img>
      </div>
      <div className="my-6">
        <div className="">
          <div className="w-1/2 bg-white py-5 px-10 rounded-xl shadow-2xl mx-auto my-4">
            <div className="grid grid-cols-2">
              <div className="flex flex-col space-y-5 justify-center">
                <div >
                  <p className="font-semibold mb-2">Enter new password</p>
                  <div className="flex space-x-3 items-center relative">
                    <input value={password} onChange={(e) => { setPassword(e.target.value) }} type={
                      !display1 ?
                        "password"
                        :
                        "text"
                    } className="w-full outline-none border-2 rounded-md px-2 py-1" placeholder="Enter password"></input>
                    {
                      display1 ?
                        <FaEye onClick={() => { setDisplay1(!display1) }} className="text-xl text-gray-500 absolute right-2"></FaEye>
                        :
                        <FaEyeSlash onClick={() => { setDisplay1(!display1) }} className="text-xl text-gray-500 absolute right-2"></FaEyeSlash>
                    }
                  </div>
                </div>
                <div >
                  <p className="font-semibold mb-2">Confirm new password</p>
                  <div className="flex space-x-3 relative items-center">
                    <input value={confirmPassword} onChange={(e) => { setConfirmPassword(e.target.value) }} type={
                      !display2 ?
                        "password"
                        :
                        "text"
                    } className="w-full outline-none border-2 rounded-md px-2 py-1" placeholder="Confirm password"></input>
                    {
                      display2 ?
                        <FaEye onClick={() => { setDisplay2(!display2) }} className="text-xl text-gray-500 absolute right-2"></FaEye>
                        :
                        <FaEyeSlash onClick={() => { setDisplay2(!display2) }} className="text-xl text-gray-500 absolute right-2"></FaEyeSlash>
                    }
                  </div>
                </div>


                <div >
                  <button disabled={(!((password == confirmPassword) && (password)))} onClick={() => { nav() }} className={((password == confirmPassword) && (password)) ? "bg-[#148EFF] text-white w-full rounded-xl py-3" : "bg-gray-400 text-white w-full rounded-xl py-3"}>Change Password</button>
                </div>
              </div>
              <div>
                <img src={login}></img>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  )
}

export default ResetPassword